import React, { useContext, useState } from 'react';
import { Col, Row } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { HaierCostingContext } from 'views/Costing/common/context/HaierCostingContext';
import { useHistory } from 'react-router-dom';
import { HaierCostingStatus } from 'views/Costing/common/model/haierCostingStatus.model';
import { Container, StyledButton, TextHeader } from './Styles';
import ModalConfirmReject from './ModalConfirmReject';
import ModalConfirmChecked from './ModalConfirmChecked';
import ModalConfirmCosting from './ModalConfirmCosting';

const Header: React.FC = () => {
  const history = useHistory();
  const [isOpenModalConfirmReject, setOpenModalConfirmReject] = useState<boolean>(false);
  const [isOpenModalConfirmCosting, setOpenModalConfirmCosting] = useState<boolean>(false);
  const [isOpenModalConfirmChecked, setOpenModalConfirmChecked] = useState<boolean>(false);
  const { selectedCostingDetail } = useContext(HaierCostingContext);
  const { costingNumber, costingStatus, isLoading, backUrl } = selectedCostingDetail!;

  const closeModalHandler = () => {
    history.push(backUrl);
  };

  return (
    <Container>
      <Row justify="space-between" align="middle">
        <Col>
          <TextHeader>รหัสต้นทุน/ขาย: {costingNumber}</TextHeader>
        </Col>
        <Col>
          {costingStatus === HaierCostingStatus.WAITING_CONFIRM && (
            <>
              <StyledButton
                disabled={isLoading}
                icon={<CheckCircleOutlined />}
                color="green"
                onClick={() => setOpenModalConfirmCosting(true)}
              >
                ส่งตรวจสอบ
              </StyledButton>
              <ModalConfirmCosting
                visible={isOpenModalConfirmCosting}
                onCancel={() => setOpenModalConfirmCosting(false)}
              />
            </>
          )}
          {costingStatus === HaierCostingStatus.TO_VERIFY && (
            <>
              <StyledButton
                disabled={isLoading}
                icon={<CheckCircleOutlined />}
                color="green"
                onClick={() => setOpenModalConfirmChecked(true)}
              >
                ตรวจสอบแล้ว
              </StyledButton>
              <ModalConfirmChecked
                visible={isOpenModalConfirmChecked}
                onCancel={() => setOpenModalConfirmChecked(false)}
              />

              <StyledButton
                disabled={isLoading}
                icon={<CloseCircleOutlined />}
                color="red--light"
                onClick={() => setOpenModalConfirmReject(true)}
              >
                ปฏิเสธ
              </StyledButton>
              <ModalConfirmReject
                visible={isOpenModalConfirmReject}
                onCancel={() => setOpenModalConfirmReject(false)}
              />
            </>
          )}

          <StyledButton onClick={closeModalHandler}>ปิด</StyledButton>
        </Col>
      </Row>
    </Container>
  );
};

export default Header;
